import { render, staticRenderFns } from "./ToimittajaLaskutuksenYhteenveto.vue?vue&type=template&id=1b5697ff&scoped=true&"
import script from "./ToimittajaLaskutuksenYhteenveto.vue?vue&type=script&lang=js&"
export * from "./ToimittajaLaskutuksenYhteenveto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5697ff",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})


/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b5697ff')) {
      api.createRecord('1b5697ff', component.options)
    } else {
      api.reload('1b5697ff', component.options)
    }
    module.hot.accept("./ToimittajaLaskutuksenYhteenveto.vue?vue&type=template&id=1b5697ff&scoped=true&", function () {
      api.rerender('1b5697ff', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/ToimittajaLaskutuksenYhteenveto.vue"
export default component.exports